import React from "react";
import { Modal } from "antd";

const DeletConformation = ({
    isVisible,
    onCancel,
    onConfirm,
    message = "Are you sure you want to delete this item?",
}) =>{
    return(
        <Modal
      title="Delete"
      visible={isVisible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Delete"
      cancelText="Cancel"
    >
      <p>{message}</p>
    </Modal>
    )

}

export default DeletConformation;